// Copyright 2025, University of Maryland, All Rights Reserved
import { apiClient } from './api-client';
import type {
  SchedulerRecord,
  CreateSchedulerRequest,
  UpdateSchedulerRequest,
} from './types/scheduler';

/**
 * List all scheduler records
 */
export async function listSchedulers(): Promise<SchedulerRecord[]> {
  const response = await apiClient.get<SchedulerRecord[]>('/admin/schedulers');
  return response.data;
}

/**
 * Create a new scheduler record
 */
export async function createScheduler(
  data: CreateSchedulerRequest,
): Promise<SchedulerRecord> {
  const response = await apiClient.post<SchedulerRecord>('/admin/schedulers', data);
  return response.data;
}

/**
 * Update an existing scheduler record
 */
export async function updateScheduler(
  job_name: string,
  data: UpdateSchedulerRequest,
  org?: string | null,
  ws?: string | null,
  scope?: string | null,
): Promise<SchedulerRecord> {
  const params: Record<string, string> = {};
  if (org) params.org = org;
  if (ws) params.ws = ws;
  if (scope) params.scope = scope;

  const response = await apiClient.put<SchedulerRecord>(
    `/admin/schedulers/${encodeURIComponent(job_name)}`,
    data,
    { params },
  );
  return response.data;
}

/**
 * Delete a scheduler record
 */
export async function deleteScheduler(
  job_name: string,
  org?: string | null,
  ws?: string | null,
  scope?: string | null,
): Promise<void> {
  const params: Record<string, string> = {};
  if (org) params.org = org;
  if (ws) params.ws = ws;
  if (scope) params.scope = scope;

  await apiClient.delete(`/admin/schedulers/${encodeURIComponent(job_name)}`, {
    params,
  });
}
